import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import classes from './LegalPage.module.scss';

const BallAdventuresPrivacy = () => {
  return (
    <LegalPageLayout
      title="Ball Adventures — Privacy Policy"
      lastUpdated="August 2, 2026"
      documentTitle="Ball Adventures — Privacy Policy | Arsanyu Technologies"
      intro={
        <>
          Ball Adventures (&ldquo;the game&rdquo;) is developed and published by{' '}
          <strong>Arsanyu Technologies Pvt. Ltd.</strong>
        </>
      }
    >
      <section className={classes.callout}>
        <h2>Data we collect</h2>
        <p>
          Ball Adventures itself does not collect, store, or share any personal
          data.
        </p>
        <ul>
          <li>
            All game progress (levels, gems, unlocked balls, settings) is stored
            only on your device using local storage. It never leaves your phone.
          </li>
          <li>
            The game does not require an account and does not access your
            contacts, location, camera, microphone, or files.
          </li>
          <li>The game can be played fully offline.</li>
        </ul>
      </section>

      <section>
        <h2>Advertising</h2>
        <p>
          The game shows interstitial ads and optional rewarded video ads (you
          can choose to watch rewarded ads for in-game rewards). Ads are
          provided by Google AdMob.
        </p>
        <p>To serve and measure ads, Google may collect and process:</p>
        <ul>
          <li>Device advertising identifier (Advertising ID)</li>
          <li>IP address and coarse device information (model, OS version)</li>
          <li>Ad interaction data (views, clicks)</li>
        </ul>
        <p>
          This processing is governed by Google&rsquo;s Privacy Policy:{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy
          </a>
        </p>
        <p>
          For users in the EEA/UK, a consent form is shown before any ad-related
          data is processed, as required by GDPR. If you decline, ads shown will
          be non-personalized. You can also reset your device&rsquo;s
          Advertising ID or opt out of ad personalization in your device
          settings.
        </p>
      </section>

      <section>
        <h2>Google Play Games Services</h2>
        <p>
          The game offers optional sign-in with Google Play Games Services for
          global leaderboards. If you sign in, Google processes your Play Games
          player ID, gamer name, and the scores you submit (distance and level
          reached), under Google&rsquo;s Privacy Policy:{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy
          </a>
        </p>
        <p>
          Sign-in is optional — you can decline it and play the full game. You
          can manage or delete your Play Games profile in your Google account
          settings (
          <a
            href="https://myaccount.google.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            myaccount.google.com
          </a>
          ) or the Play Games app.
        </p>
      </section>

      <section>
        <h2>Children</h2>
        <p>
          The game is not directed at children. It contains no chat, no social
          features, and no purchases of real goods.
        </p>
      </section>

      <section>
        <h2>Changes to this policy</h2>
        <p>
          Any changes will be published at this same address before taking
          effect.
        </p>
      </section>

      <section className={classes.contact}>
        <h2>Contact</h2>
        <p>
          Questions about this policy:{' '}
          <a href="mailto:archit9spicin@gmail.com">archit9spicin@gmail.com</a>
        </p>
      </section>
    </LegalPageLayout>
  );
};

export default BallAdventuresPrivacy;
